import { render } from "./Product.vue?vue&type=template&id=cd3bc27e&scoped=true"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=cd3bc27e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd3bc27e"]])

export default __exports__